




































































































import { defineComponent, reactive, toRefs } from '@vue/composition-api'
import {
  clientTypeOptions,
  serviceOrgOptions,
  serviceUserOptions,
  categoryOptions
} from '@/constants/app-detail'
import Views from './components/views.vue'
import $http from '@/api'

export default defineComponent({
  name: '',
  components: {
    Views
  },
  props: {},
  emits: [],
  setup(props, { root }) {
    const state = reactive({
      appInfo: {},
      devInfo: {},
      devAddress: ''
    })
    const appId = root.$route.query.appId || ''
    const developerId = root.$route.query.developerId || ''
    const getTypeLabel = (options: any, valueList: any) => {
      const data = options
        .filter((item: any) => valueList.indexOf(item.value) > -1)
        .map((item: any) => item.label)
        .join('/')
      return data
    }
    const getAddress = async () => {
      const { data } = await $http.getAddressTree()
      const devInfo: any = state.devInfo
      const addressList = data.addresses || []
      const addressData = []
      let provinceItem: any = {}
      let cityItem: any = {}
      let areaItem: any = {}
      if (devInfo.provinceId) {
        provinceItem = addressList.find(
          (item: any) => item.code === devInfo.provinceId
        )
        addressData.push(provinceItem.name)
        if (devInfo.cityId) {
          cityItem = provinceItem.subAddresses.find(
            (item: any) => item.code === devInfo.cityId
          )
          addressData.push(cityItem.name)
          if (devInfo.areaId) {
            areaItem = cityItem.subAddresses.find(
              (item: any) => item.code === devInfo.areaId
            )
            addressData.push(areaItem.name)
          }
        }
      }
      state.devAddress = addressData.join(' ')
    }
    const getAppInfo = async () => {
      const params = {
        appId,
        dataSource: 1
      }
      const { data } = await $http.appInfo(params)
      state.appInfo = data
    }
    const getDevInfo = async () => {
      const params = {
        developerId,
        source: 1
      }
      const { data } = await $http.getDevInfo(params)
      state.devInfo = data
      getAddress()
    }
    getAppInfo()
    getDevInfo()

    return {
      ...toRefs(state),
      clientTypeOptions,
      serviceOrgOptions,
      serviceUserOptions,
      categoryOptions,
      getTypeLabel
    }
  }
})
